<div class="outer-container">
  @if (!ilmoitusLahetetty()) {
    <div class="container">
      <h2>{{ 'sopimus-tauolla.tauko' | translate | async }}</h2>
      <p>{{ 'sopimus-tauolla.sopimuksesi-on-tauolla' | translate | async }}</p>
      <button class="primarybutton" mat-button (click)="lopetaTauko()">{{ 'sopimus-tauolla.lopeta-tauko' | translate | async }}</button>
    </div>
  }
  @if (ilmoitusLahetetty()) {
    <div class="container">
      <h2>{{ 'sopimus-tauolla.kiitos-yhteydenotostasi' | translate | async }}</h2>
      <p>{{ 'sopimus-tauolla.kirjanpitajan-tiedotus' | translate | async }}</p>
    </div>
  }
  @if (commonError()) {
    <div class="lemon-error">{{ commonError() }}</div>
  }
</div>
